import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FloatingAlert from 'components/Alert/FloatingAlert';
import { useAuth } from 'context/AuthContext';
import useScopedTranslation from 'hooks/useScopedTranslation';
import { impersonateI18n } from './i18n';

const Impersonate = ({ DesignSystemComponents }) => {
  const navigate = useNavigate();
  const { impersonate, authLoading } = useAuth();
  const { t } = useScopedTranslation(impersonateI18n);

  const { Card, Input, Button } = DesignSystemComponents;
  const [email, setEmail] = useState('');
  const [alert, setAlert] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlert(null);

    if (!email.trim()) {
      setAlert({
        type: 'danger',
        message: t('imp_err_required'),
      });
      return;
    }

    try {
      localStorage.removeItem('task_comment_history');

      await impersonate(email.trim());
      navigate('/');
    } catch (err) {
      setAlert({
        type: 'danger',
        message: err.message || t('imp_err_default'),
      });
    }
  };

  return (
    <div className='container mt-5'>
      <div className='row justify-content-center'>
        <div className='col-12 col-md-6 col-lg-5'>
          <Card>
            <h2 className='h5 mb-3'>{t('imp_title')}</h2>
            <p className='color-gray-600 mb-4'>
              {t('imp_description')}
            </p>

            {alert && (
              <FloatingAlert
                type={alert.type}
                message={alert.message}
                onClose={() => setAlert(null)}
              />
            )}

            <form onSubmit={handleSubmit}>
              <Input
                label={t('imp_emailLabel')}
                type='email'
                placeholder={t('imp_emailPlaceholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={authLoading}
              />

              <div className='d-flex justify-content-between'>
                <Button
                  type='button'
                  variant='secondary'
                  label={t('imp_cancel')}
                  onClick={() => navigate(-1)}
                  disabled={authLoading}
                />
                <Button
                  type='submit'
                  variant='primary'
                  label={authLoading ? t('imp_submitting') : t('imp_submit')}
                  disabled={authLoading}
                />
              </div>
            </form>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Impersonate;
